// VUE_APP_API_URL permite apontar o SPA para outra API (ex.: local/homologação) sem alterar o código.
export function getEnvironmentUrl() {
  return process.env.VUE_APP_API_URL || 'https://resellers-api.repasys.com.br';
}
